/* import __COLOCATED_TEMPLATE__ from './topic-summary-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { Topic } from 'embercom/components/reporting/automation/ai-insights/fin-insights/topics-data-resources';
interface Args {
  topic: Topic;
  subTopic: string | null;
  onSelectSubTopic: (subtopic: string | null) => void;
}

const TopicSummaryCard = class extends Component<Args> {
  get subtopicQuestions() {
    return this.args.subTopic ? this.args.topic.subtopics[this.args.subTopic] : [];
  }
};
export default TopicSummaryCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::TopicSummaryCard': typeof TopicSummaryCard;
  }
}
